var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDanger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.53125 1.44H4.375C4.46094 1.44 4.53125 1.368 4.53125 1.28V1.44H10.4688V1.28C10.4688 1.368 10.5391 1.44 10.625 1.44H10.4688V2.88H11.875V1.28C11.875 0.574 11.3145 0 10.625 0H4.375C3.68555 0 3.125 0.574 3.125 1.28V2.88H4.53125V1.44ZM14.375 2.88H0.625C0.279297 2.88 0 3.166 0 3.52V4.16C0 4.248 0.0703125 4.32 0.15625 4.32H1.33594L1.81836 14.78C1.84961 15.462 2.40039 16 3.06641 16H11.9336C12.6016 16 13.1504 15.464 13.1816 14.78L13.6641 4.32H14.8438C14.9297 4.32 15 4.248 15 4.16V3.52C15 3.166 14.7207 2.88 14.375 2.88ZM11.7832 14.56H3.2168L2.74414 4.32H12.2559L11.7832 14.56Z",
    fill: "#CF324A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDanger);
export default __webpack_public_path__ + "static/media/DeleteDanger.5787175541f39e675735ca0916d189bd.svg";
export { ForwardRef as ReactComponent };